import React from 'react';

const SearchIcon = ({color = "white"}) => (
  <svg  width="20" height="19" viewBox="0 0 20 19" fill="none">
    <path fill={color} fillRule="evenodd" clipRule="evenodd" d="M2.88818 7.25C2.88818 4.355 5.24318 2 8.13818 2C11.0332 2 13.3882 4.355 13.3882 7.25C13.3882 10.145 11.0332 12.5 8.13818 12.5C5.24318 12.5 2.88818 10.145 2.88818 7.25ZM0.888184 7.25C0.888184 11.248 4.14018 14.5 8.13818 14.5C9.76645 14.5 11.271 13.9606 12.4825 13.0511L18.1842 18.71C18.3782 18.903 18.6332 19 18.8882 19C19.1452 19 19.4032 18.901 19.5982 18.704C19.9872 18.313 19.9852 17.68 19.5922 17.29L13.9024 11.6429C14.8342 10.4232 15.3882 8.90013 15.3882 7.25C15.3882 3.252 12.1362 0 8.13818 0C4.14018 0 0.888184 3.252 0.888184 7.25Z"/>
  </svg>
);

export default SearchIcon;